import momentsData from "../moments.json";

/** A "moment" of the wedding day — the album's top-level organizational unit. */
export interface MomentDef {
  /** Stable slug, e.g. "first-dance". Used as the public id everywhere. */
  key: string;
  /** Display name, e.g. "First Dance". */
  label: string;
  /** One-line caption shown under the title. */
  desc: string;
  /** CLIP zero-shot prompt used by the AI worker to classify photos into this moment. */
  prompt: string;
  /** Keyword list powering the natural-language search keyword-fusion arm. */
  keywords: string[];
  /** Two-stop watercolor wash used for placeholder covers in the UI. */
  wash: [string, string];
  /** Order the moments appear in the album (chronological-ish). */
  sortOrder: number;
}

export const MOMENTS: MomentDef[] = momentsData as MomentDef[];

export const MOMENT_KEYS = MOMENTS.map((m) => m.key);

export function momentByKey(key: string): MomentDef | undefined {
  return MOMENTS.find((m) => m.key === key);
}

/** Suggested natural-language search prompts surfaced as chips. */
export const SUGGESTED_SEARCHES = [
  "Show me the first dance",
  "Show me the vows",
  "Show me cake cutting",
  "Show me the speeches",
  "Show me dancing",
  "Show me sunset pictures",
];
